import { __extends, __decorate, __spreadArray, __assign } from 'tslib';

var AppendersRegistry = new Map();

/**
 * Logger 日志渠道
 *
 * @export
 * @param {IAppenderOptions} options
 * @returns
 */
function Appender(options) {
    return function (target) {
        // eslint-disable-next-line no-param-reassign
        target.prototype.appenderOptions = options;
        AppendersRegistry.set(options.name, { provide: target });
    };
}

var LayoutsRegistry = new Map();

var Layouts = /** @class */ (function () {
    function Layouts() {
    }
    Layouts.get = function (name, config) {
        var layoutName = name;
        if (!LayoutsRegistry.has(name)) {
            layoutName = 'basic';
            console.warn("".concat(name, " layout doesn't exists"));
        }
        var layoutClass = LayoutsRegistry.get(layoutName);
        return new layoutClass.provide(config !== null && config !== void 0 ? config : {});
    };
    return Layouts;
}());

var BaseAppender = /** @class */ (function () {
    function BaseAppender() {
        this.config = {};
        this.appenderOptions = { name: '' };
        this.configure({});
    }
    BaseAppender.prototype.configure = function (config) {
        var _a;
        Object.assign(this.config, config);
        if (config.layout) {
            this.useLayout = Layouts.get(config.layout.type, config.layout);
            return;
        }
        this.useLayout = Layouts.get((_a = this.appenderOptions.defaultLayout) !== null && _a !== void 0 ? _a : 'basic');
    };
    BaseAppender.prototype.layout = function (loggingEvent) {
        return this.useLayout.transform(loggingEvent);
    };
    return BaseAppender;
}());

var ConsoleAppender = /** @class */ (function (_super) {
    __extends(ConsoleAppender, _super);
    function ConsoleAppender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsoleAppender.prototype.write = function (event) {
        var level = event.level;
        if (level.isGreaterThanOrEqualTo('ERROR')) {
            return console.error.apply(console, this.layout(event));
        }
        if (level.isEqualTo('WARN')) {
            return console.warn.apply(console, this.layout(event));
        }
        if (level.isEqualTo('INFO')) {
            return console.info.apply(console, this.layout(event));
        }
        return console.log.apply(console, this.layout(event));
    };
    ConsoleAppender = __decorate([
        Appender({ name: 'console' })
    ], ConsoleAppender);
    return ConsoleAppender;
}(BaseAppender));

/**
 * 声明一个 Layout 格式的装饰器
 * @param options
 */
function Layout(options) {
    return function (target) {
        LayoutsRegistry.set(options.name, { provide: target });
    };
}

function format(fmt) {
  var re = /(%?)(%([jds]))/g
    , args = Array.prototype.slice.call(arguments, 1);
  if(args.length) {
    fmt = fmt.replace(re, function(match, escaped, ptn, flag) {
      var arg = args.shift();
      switch(flag) {
        case 's':
          arg = '' + arg;
          break;
        case 'd':
          arg = Number(arg);
          break;
        case 'j':
          arg = JSON.stringify(arg);
          break;
      }
      if(!escaped) {
        return arg; 
      }
      args.unshift(arg);
      return match;
    });
  }

  // arguments remain after formatting
  if(args.length) {
    fmt += ' ' + args.join(' ');
  }

  // update escaped %% values
  fmt = fmt.replace(/%{2,2}/g, '%');

  return '' + fmt;
}

var format_1 = format;

function formatLogData(logData) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var data = logData;
    if (!Array.isArray(data)) {
        data = __spreadArray([data], args, true);
    }
    return format_1.apply(void 0, data);
}
function offset(timezoneOffset) {
    var os = Math.abs(timezoneOffset);
    var h = String(Math.floor(os / 60));
    var m = String(os % 60);
    if (h.length === 1) {
        h = "0".concat(h);
    }
    if (m.length === 1) {
        m = "0".concat(m);
    }
    return timezoneOffset < 0 ? "+".concat(h).concat(m) : "-".concat(h).concat(m);
}
function formatDateTime(date, format) {
    if (format === void 0) { format = 'yyyy-MM-ddThh:mm:ss.SSS'; }
    var vDay = "".concat(date.getDate()).padStart(2, '0');
    var vMonth = "".concat(date.getMonth() + 1).padStart(2, '0');
    var vYearLong = "".concat(date.getFullYear()).padStart(2, '0');
    var vYearShort = "".concat(vYearLong).substring(2, 4);
    var vYear = format.indexOf('yyyy') > -1 ? vYearLong : vYearShort;
    var vHour = "".concat(date.getHours()).padStart(2, '0');
    var vMinute = "".concat(date.getMinutes()).padStart(2, '0');
    var vSecond = "".concat(date.getSeconds()).padStart(2, '0');
    var vMillisecond = "".concat(date.getMilliseconds()).padStart(3, '0');
    var vTimeZone = offset(date.getTimezoneOffset());
    var formatted = format
        .replace(/dd/g, vDay)
        .replace(/MM/g, vMonth)
        .replace(/y{1,4}/g, vYear)
        .replace(/hh/g, vHour)
        .replace(/mm/g, vMinute)
        .replace(/ss/g, vSecond)
        .replace(/SSS/g, vMillisecond)
        .replace(/O/g, vTimeZone);
    return formatted;
}

var BaseLayout = /** @class */ (function () {
    function BaseLayout() {
    }
    return BaseLayout;
}());

var BasicLayout = /** @class */ (function (_super) {
    __extends(BasicLayout, _super);
    function BasicLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * BasicLayout 是一个最基本的日志格式，其格式如下：
     * <pre>
     * [startTime] [logLevel] [categoryName] - message\n
     * </pre>
     */
    BasicLayout.prototype.transform = function (loggingEvent) {
        var prefix = formatLogData('[%s] [%s] [%s] - ', formatDateTime(loggingEvent.startTime), loggingEvent.formatedLevel, loggingEvent.categoryName);
        if (typeof loggingEvent.data === 'string') {
            return [prefix + loggingEvent.data];
        }
        return [prefix, loggingEvent.data];
    };
    BasicLayout = __decorate([
        Layout({ name: 'basic' })
    ], BasicLayout);
    return BasicLayout;
}(BaseLayout));

var LogEvent = /** @class */ (function () {
    /**
       * 一个 Log 事件
       * @constructor
       * @param {String} _categoryName Log 类别
       * @param {LogLevel} _level Log 等级
       * @param {Array} _data Log 数据
       * @param _context
       */
    function LogEvent(_categoryName, _level, _data, _context) {
        this._categoryName = _categoryName;
        this._level = _level;
        this._data = _data;
        this._context = _context;
        this._startTime = new Date();
    }
    Object.defineProperty(LogEvent.prototype, "startTime", {
        get: function () {
            return this._startTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogEvent.prototype, "categoryName", {
        get: function () {
            return this._categoryName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogEvent.prototype, "level", {
        get: function () {
            return this._level;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogEvent.prototype, "formatedLevel", {
        get: function () {
            return this.level.toString().padEnd(5, ' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogEvent.prototype, "data", {
        get: function () {
            if (this._data.length > 1) {
                return this._data;
            }
            return this._data[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogEvent.prototype, "context", {
        get: function () {
            return this._context;
        },
        enumerable: false,
        configurable: true
    });
    return LogEvent;
}());

// eslint-disable-next-line prefer-const
var DEFAULT_LOG_LEVELS;
var LogLevel = /** @class */ (function () {
    function LogLevel(level, levelStr) {
        this.level = level;
        this.levelStr = levelStr;
        this.level = level;
        this.levelStr = levelStr;
    }
    LogLevel.getLevel = function (sArg, defaultLevel) {
        if (sArg instanceof LogLevel) {
            return sArg;
        }
        if (typeof sArg === 'string') {
            return DEFAULT_LOG_LEVELS[sArg.toUpperCase()] || defaultLevel;
        }
        return this.getLevel(sArg.toString());
    };
    LogLevel.prototype.toString = function () {
        return this.levelStr;
    };
    LogLevel.prototype.isLessThanOrEqualTo = function (logLevel) {
        return this.level <= LogLevel.getLevel(logLevel).level;
    };
    LogLevel.prototype.isGreaterThanOrEqualTo = function (logLevel) {
        return this.level >= LogLevel.getLevel(logLevel).level;
    };
    LogLevel.prototype.isEqualTo = function (logLevel) {
        return this.level === LogLevel.getLevel(logLevel).level;
    };
    return LogLevel;
}());
DEFAULT_LOG_LEVELS = {
    ALL: new LogLevel(Number.MIN_VALUE, 'ALL'),
    TRACE: new LogLevel(5000, 'TRACE'),
    DEBUG: new LogLevel(10000, 'DEBUG'),
    INFO: new LogLevel(20000, 'INFO'),
    WARN: new LogLevel(30000, 'WARN'),
    ERROR: new LogLevel(40000, 'ERROR'),
    FATAL: new LogLevel(50000, 'FATAL'),
    MARK: new LogLevel(9007199254740992, 'MARK'), // 2^53
    OFF: new LogLevel(Number.MAX_VALUE, 'OFF'),
};
function levels() {
    return DEFAULT_LOG_LEVELS;
}

var LoggerAppenders = /** @class */ (function () {
    function LoggerAppenders() {
        this.appenders = new Map();
        this.levels = new Map();
    }
    Object.defineProperty(LoggerAppenders.prototype, "size", {
        /**
         * 获取渠道数量
         */
        get: function () {
            return this.appenders.size;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 判断是否有某个渠道
     * @param name 渠道名
     */
    LoggerAppenders.prototype.has = function (name) {
        return this.appenders.has(name);
    };
    /**
     * 获取某个日志渠道
     * @param name 渠道名
     */
    LoggerAppenders.prototype.get = function (name) {
        return this.appenders.get(name);
    };
    /**
     * 添加或配置一个日志渠道
     * @param name 渠道名
     * @param config 渠道配置
     */
    LoggerAppenders.prototype.set = function (name, config) {
        if (!AppendersRegistry.has(name)) {
            var error = new Error("Appender ".concat(name, " doesn't exists. Check your configuration:\n").concat(JSON.stringify(config), "\n"));
            error.name = 'UNKNOW_APPENDER';
            throw error;
        }
        var Klass = AppendersRegistry.get(name).provide;
        var instance = new Klass(config);
        this.appenders.set(name, { instance: instance, config: config });
        this.levels.clear();
        return this;
    };
    /**
     * 移除某个渠道
     * @param name 渠道名
     */
    LoggerAppenders.prototype.delete = function (name) {
        var existed = this.appenders.delete(name);
        if (existed) {
            this.levels.clear();
        }
        return existed;
    };
    /**
     * 清除所有渠道
     */
    LoggerAppenders.prototype.clear = function () {
        this.appenders.clear();
        this.levels.clear();
    };
    /**
     * 遍历渠道
     * @param callback 遍历回调
     * @param thisArg this 指向
     */
    LoggerAppenders.prototype.forEach = function (callback, thisArg) {
        this.appenders.forEach(callback, thisArg);
    };
    /**
     * 返回所有支持特定级别的日志渠道
     * @param loggingLevel 日志级别
     */
    LoggerAppenders.prototype.byLogLevel = function (loggingLevel) {
        var level = loggingLevel.toString();
        if (this.levels.has(level)) {
            return this.levels.get(level);
        }
        var list = this.toArray()
            .filter(function (appender) { return (appender.config.levels
            ? appender.config.levels.find(function (lvl) { return lvl.toUpperCase() === loggingLevel.toString(); })
            : true); })
            .map(function (appender) { return appender.instance; });
        this.levels.set(loggingLevel.toString(), list);
        return list;
    };
    LoggerAppenders.prototype.toArray = function () {
        var array = [];
        this.appenders.forEach(function (o) { return array.push(o); });
        return array;
    };
    return LoggerAppenders;
}());

var DEFAULT_LEVEL = 'ALL';
var Logger = /** @class */ (function () {
    function Logger(name) {
        this.name = name;
        /**
         * Logger 所使用的 Appender 日志渠道
         */
        this.appenders = new LoggerAppenders();
    }
    /**
     * 基于当前位置生成堆栈
     */
    Logger.createStack = function () {
        var _a;
        var stack = ((_a = new Error().stack) !== null && _a !== void 0 ? _a : '').replace('Error\n', '');
        var array = stack.split('\n');
        if (array[0].indexOf('Logger.') > -1) { // 移除当前 Service
            array.splice(0, 1);
        }
        if (array[0].indexOf('Logger.') > -1) { // 移除调用者
            array.splice(0, 1);
        }
        return array.join('\n');
    };
    Object.defineProperty(Logger.prototype, "level", {
        get: function () {
            if (this.currentLevel) {
                return this.currentLevel.toString();
            }
            return LogLevel.getLevel(DEFAULT_LEVEL).toString();
        },
        /**
         * Logger 当前最低输出的 Log 级别
         */
        set: function (level) {
            this.currentLevel = LogLevel.getLevel(level, DEFAULT_LEVEL);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 为当前 Logger 使用某一个日志渠道
     * @param appender 渠道名
     * @param config 渠道配置
     */
    Logger.prototype.use = function (appender, config) {
        this.appenders.set(appender, __assign({ layout: { type: 'basic' }, levels: ['trace', 'debug', 'info', 'warn', 'error', 'fatal'] }, config));
        return this;
    };
    /**
     * 判断日志等级是否可用
     * @param level 日志等级
     */
    Logger.prototype.isLevelEnabled = function (level) {
        if (this.currentLevel) {
            return this.currentLevel.isLessThanOrEqualTo(level);
        }
        return LogLevel.getLevel(DEFAULT_LEVEL).isLessThanOrEqualTo(level);
    };
    /**
     * 打一条开发日志
     */
    Logger.prototype.debug = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return this.write(levels().DEBUG, data);
    };
    /**
     * 打堆栈日志
     */
    Logger.prototype.trace = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        var stack = "\n".concat(Logger.createStack(), "\n");
        data.push(stack);
        return this.write(levels().TRACE, data);
    };
    /**
     * 打一条信息日志
     */
    Logger.prototype.info = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return this.write(levels().INFO, data);
    };
    /**
     * 打一条警告日志
     */
    Logger.prototype.warn = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return this.write(levels().WARN, data);
    };
    /**
     * 打一条错误日志
     */
    Logger.prototype.error = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return this.write(levels().ERROR, data);
    };
    /**
     * 打一条致命错误日志
     */
    Logger.prototype.fatal = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return this.write(levels().FATAL, data);
    };
    Logger.prototype.write = function (logLevel, data) {
        if (!this.isLevelEnabled(logLevel))
            return this;
        var logEvent = new LogEvent(this.name, logLevel, data, this.context);
        this.appenders
            .byLogLevel(logLevel)
            .forEach(function (appender) {
            appender.write(logEvent);
        });
        return this;
    };
    return Logger;
}());

Appender({ name: 'console' })(ConsoleAppender);
Layout({ name: 'basic' })(BasicLayout);

export { Appender, BaseAppender, BaseLayout, Layout, Logger };
//# sourceMappingURL=index.js.map
